import List from 'components/List'
import Panel from 'components/Panel'

const RelatedContent = ({
  faqs,
  tutorials,
  deviceId,
  isFetching,
  renderItemList
}) => (
  <Panel title="Related Articles">
    {!isFetching && (
      <>
        {tutorials.length !== 0 && (
          <List title="Related Tutorials:">
            {renderItemList(tutorials, { deviceId })}
          </List>
        )}

        {faqs.length !== 0 && (
          <List title="Related FAQs:">
            {renderItemList(faqs, { deviceId })}
          </List>
        )}

        {faqs.length === 0 && tutorials.length === 0 && (
          <div>This topic does not have other related content.</div>
        )}
      </>
    )}
  </Panel>
)

export default RelatedContent
